export default __webpack_public_path__ + "static/media/ShallowFloatingBowl.a0c18316.png";